import visitService from "../api/services/visitService";
import { EU_COUNTRIES } from "@/utils/variables";
import { Visit } from "@/interfaces/Visit";
import { defineStore } from "pinia";
import { useLandingStore } from "@/store/landing.ts";
import { getFreeareaVideoPoster } from "@/utils/mediaHelper.ts";
import { Landing } from "@/interfaces/Landing.ts";
import { appendPreloadImage } from "@/utils/appendPreloadImage.ts";

const LANDING_HERO_POSTER_PRELOAD_ID = "landing-hero-poster-preload";

interface VisitState {
  visit: Visit | null;
  trackVisitPromise: Promise<void> | null;
}

export const useVisitStore = defineStore("visit", {
  state: (): VisitState => ({
    visit: null,
    trackVisitPromise: null,
  }),

  getters: {
    getVisit: (state: VisitState) => state.visit,
    isEUCountry: (state: VisitState) => EU_COUNTRIES.includes(state.visit?.country.toUpperCase() ?? ""),
  },

  actions: {
    async trackVisit(lang?: "en" | "de" | "fr") {
      this.visit = await visitService.trackVisit(lang);

      if (this.visit.landing) {
        useLandingStore().setLandingPage(this.visit.landing);
        this.preloadLandingHeroPoster(this.visit.landing);
      }
    },
    async ensureVisitTracked(lang?: "en" | "de" | "fr") {
      if (this.visit) {
        return;
      }

      if (!this.trackVisitPromise) {
        this.trackVisitPromise = this.trackVisit(lang).finally(() => {
          this.trackVisitPromise = null;
        });
      }

      await this.trackVisitPromise;
    },

    preloadLandingHeroPoster(landing: Landing) {
      const thumb = landing.hero_videos?.[0]?.thumb;

      if (!thumb) {
        return;
      }

      appendPreloadImage(getFreeareaVideoPoster(thumb), LANDING_HERO_POSTER_PRELOAD_ID);
    },
  },
});
